module.exports = __webpack_public_path__ + "img/Component11–1(HoverState).e5771b8c.png";